// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Q0iF","top":"styles_top__1yO40"};